import React from 'react';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

export const Wheel: React.FC<{ spinning: boolean }> = ({ spinning }) => {
  const spinningStyles = (duration: number): CSSProperties => ({
    transformBox: 'fill-box',
    transformOrigin: 'center',
    animation: `spin ${duration}s linear infinite`,
  });

  return (
    <svg width="24px" height="24px">
      <path
        style={spinning ? spinningStyles(6) : undefined}
        d="M13.6,11.5c0.3-0.5,0.5-1,0.6-1.5H16V7h-1.7c-0.1-0.5-0.3-1-0.6-1.5l1.2-1.2l-2.1-2.1l-1.2,1.2
	C11,3,10.5,2.9,10,2.7V1H7v1.7C6.5,2.9,6,3,5.5,3.4L4.2,2.1L2.1,4.2l1.2,1.2C3,6,2.9,6.5,2.7,7H1v3h1.7c0.1,0.5,0.3,1,0.6,1.5
	l-1.2,1.2l2.1,2.1l1.2-1.2c0.4,0.3,1,0.5,1.5,0.6V16h3v-1.7c0.5-0.1,1-0.3,1.5-0.6l1.2,1.2l2.1-2.1L13.6,11.5z M8.5,10.5
	c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S9.6,10.5,8.5,10.5z"
      />
      <path
        style={spinning ? spinningStyles(2.5) : undefined}
        d="M23,19v-2h-1.6c-0.1-0.2-0.2-0.5-0.3-0.7l1.2-1.2l-1.4-1.4l-1.2,1.2
	c-0.2-0.1-0.4-0.2-0.7-0.3V13h-2v1.6c-0.2,0.1-0.5,0.2-0.7,0.3l-1.2-1.2l-1.4,1.4l1.2,1.2c-0.1,0.2-0.2,0.4-0.3,0.7H13v2h1.6
	c0.1,0.2,0.2,0.5,0.3,0.7l-1.2,1.2l1.4,1.4l1.2-1.2c0.2,0.1,0.4,0.2,0.7,0.3V23h2v-1.6c0.2-0.1,0.5-0.2,0.7-0.3l1.2,1.2l1.4-1.4
	l-1.2-1.2c0.1-0.2,0.2-0.4,0.3-0.7H23z M18,19c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S18.6,19,18,19z"
      />
    </svg>
  );
};

export const MovieControlPlay: React.FC = () => {
  return (
    <svg style={{ width: 24, height: 24 }}>
      <path d="M12,1C5.92,1,1,5.92,1,12s4.92,11,11,11s11-4.92,11-11S18.08,1,12,1z M8,19V5l12,7L8,19z" />
    </svg>
  );
};

export const RedoAlt: React.FC = () => {
  return (
    <svg style={{ width: 24, height: 24 }}>
      <path d="M19.8,4.2C17.8,2.2,15,1,12,1C5.9,1,1,5.9,1,12s4.9,11,11,11c3,0,5.6-1.2,7.5-3l-2.6-3c-1.2,1.2-3,2-4.9,2c-3.8,0-7-3.2-7-7  s3.2-7,7-7c2,0,3.8,0.8,5,2l-3,3h9V1L19.8,4.2z" />
    </svg>
  );
};
